import React from 'react';
import { BiCopy } from 'react-icons/bi';

import { Container } from 'src/components/Container';
import Badge from 'src/components/Table/Row/Badge';

import { convertDate, formatFieldString, shortenString } from 'src/components/Table/helpers';
import { Screenshot } from 'src/pages/PresaleOrders/OrderDetailsModal';
import { useDispatch } from 'src/store/useDispatch';
import { setAppAlert } from 'src/store/slice/appAlert';
import { formatBigNumber } from 'src/utils/constants';

interface IListItemRenderer {
  item: any;
  field: string;
  isModal?: boolean;
}

const ListItemRenderer: React.FC<IListItemRenderer> = ({ item, field, isModal = false }) => {
  const dispatch = useDispatch();

  if (field === 'created_at' || field === 'updated_at' || field === 'birthdate') {
    return (
      <Container display={isModal ? 'flex' : 'block'} gap="0.5rem">
        <Container>{convertDate(item[field]).date}</Container>
        <Container>{convertDate(item[field]).time}</Container>
      </Container>
    );
  }

  if (field === 'status' || field === 'kyc_status') {
    return <Badge value={item[field] ?? '-'} />;
  }

  if (field === 'photo_url' || field === 'front' || field === 'back' || field === 'payment_screenshot') {
    // return <img src={item[field]} style={{ maxWidth: '20rem' }} />;
    return <Screenshot src={item[field]} alt="Photo" onClick={() => window.open(item[field], '_blank')} />;
  }

  if (
    field === '_id' ||
    field === 'id' ||
    field === 'kyc_id' ||
    field === 'user_id' ||
    field === 'email' ||
    field === 'recipient_address' ||
    field === 'from' ||
    field === 'owner' ||
    field === 'crypto_api_transaction_request_id' ||
    field === 'presale_user_id' ||
    field === 'order_number' ||
    field === 'deposit_address' ||
    field === 'blockchain_transaction_id'
  ) {
    return (
      <Container
        display="flex"
        alignItems="center"
        justifyContent={isModal ? 'space-between' : 'flex-start'}
        gap="0.5rem"
        width={isModal ? '100%' : undefined}
      >
        <Container>{shortenString(item[field])}</Container>
        {isModal && (
          <Container
            onClick={() => {
              navigator.clipboard.writeText(item[field]);
              dispatch(
                setAppAlert({
                  message: `${formatFieldString(field)} copied`,
                  isSuccess: true,
                }),
              );
            }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="16px"
            cursor="pointer"
            alignSelf="center"
          >
            <BiCopy height={20} width={20} />
          </Container>
        )}
      </Container>
    );
  }

  // Format currency fields with dollar sign
  if (
    field === 'amount_in_usd' ||
    field === 'bxlend_token_base_price' ||
    field === 'coin_price' ||
    field === 'coin_converted_price'
  ) {
    const value = item[field];
    if (value === null || value === undefined) return <span>-</span>;
    return <span>${formatBigNumber(value)}</span>;
  }

  // Format token allocation with BXT suffix
  if (field === 'token_allocation') {
    const value = item[field];
    if (value === null || value === undefined) return <span>-</span>;
    return <span>{formatBigNumber(value)} BXT</span>;
  }

  return <div style={{ wordBreak: 'break-all' }}>{item[field] ?? '-'}</div>;
};

export default ListItemRenderer;
